import React from 'react'
import './GetTouch.css'

function GetTouch() {
  return (
    
    <div className="container-fluid add " style={{ backgroundImage: "url('/Image/gii.jpg')" }}>
  <div className="content mt-5">
    <span className='demo99'>CONTACT US</span>
    <h2>Get In Touch</h2>
    <p>Phone <br></br>
    +91-8530434964<br></br>
    +91-9986554887</p>
    <p>Email <br></br>
    Support@Narayanisolutions.com
     </p>
    
    <b>Address :</b>
  <p>
    <b>Office 1:</b> IT-7 Building, Qubix Business Parks,
    <br></br>
Phase 1, Hinjawadi, Pune, Maharashtra 411057
  </p>
  <p>
    <b>Office 2:</b> #501,Shanti Heights,<br />
Manish Nagar, Nagpur - 440015,
MAHARASHTRA,
 India
  </p>
  </div>
  <div className="video mt-5">
  <video className=" shadow" autoPlay muted loop>
            <source src="video\Green Gradient.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
  </div>
  </div>

  )
}

export default GetTouch
